import { useEffect, useRef } from 'react';

import { useAirModal } from '@air/provider-modal';

import { DemoFormModal } from '~/components/Modals/DemoFormModal';
import { QueryParamNames } from '~/constants/search';
import { useRouterQueryState } from '~/utils/useRouterQueryState';

const QUERY_PARAMS = [QueryParamNames.demoModal];

export const useShowDemoFormModal = () => {
  const [showDemoFormModal] = useAirModal(DemoFormModal);
  const hasShownRef = useRef(false);
  const { values, setValues } = useRouterQueryState(QUERY_PARAMS);

  useEffect(() => {
    if (hasShownRef.current) return;

    if (values.demoModal === 'true') {
      hasShownRef.current = true;
      setValues({ [QueryParamNames.demoModal]: null });
      showDemoFormModal();
    }
  }, [values.demoModal, setValues, showDemoFormModal]);
};
